import {applyMiddleware, createStore} from "redux";
import {createLogger as logger} from "redux-logger";
import thunk from "redux-thunk";
import promise from "redux-promise-middleware";
import {rootReducer} from "./reducers";

let middlewareChain = [
  promise(),
  thunk
];

if (process.env.NODE_ENV === 'development') {
  middlewareChain.push(logger());
}
const composeStoreWithMiddleware = applyMiddleware(...middlewareChain)(createStore);

export default composeStoreWithMiddleware(rootReducer);



// WEBPACK FOOTER //
// ./src/store.js